import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CKEditor from '@ckeditor/ckeditor5-vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import VueConfetti from 'vue-confetti'
import VueMultiselect from 'vue-multiselect'

import { ColorPicker } from 'vue3-colorpicker'
import 'vue3-colorpicker/style.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(CKEditor).mount('#app')
  nuxtApp.vueApp.component('ck-editor', CKEditor)
  nuxtApp.vueApp.component('VueMultiselect', VueMultiselect)
  nuxtApp.vueApp.component('Swiper', Swiper)
  nuxtApp.vueApp.component('SwiperSlide', SwiperSlide)
  nuxtApp.vueApp.component('ColorPicker', ColorPicker)
  nuxtApp.vueApp.use(VueConfetti)

  return {
    provide: {
      CKEditor,
      ClassicEditor,
    },
  }
})
